// Services
import { type BlocBoutonDActionType } from '@/services/blocksSchema';

// Components
import Button from '@/components/atoms/Button/Button';

// Style
import styles from './BlocBoutonDAction.module.css';

interface BlocBoutonDActionProps {
  button: BlocBoutonDActionType['button'];
}

function BlocBoutonDAction({
  button,
}: BlocBoutonDActionProps) {
  
  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <Button
          title={button.title}
          url={button.url}
          bgColor='red'
        />
      </div>
    </div>
  );
}

export default BlocBoutonDAction;